import { TextField } from '@hypeit-gmbh/hypeit-ui';
import { Grid, TextInputProps } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { DEFAULT_SPAN, TRANS_KEY, useAddressPrefix } from '../Root';

type CityEnglishProps = {
  span?: number;
} & TextInputProps;

export const CityEnglish: React.FC<CityEnglishProps> = ({ span, ...props }) => {
  const { t } = useTranslation();
  const prefix = useAddressPrefix();

  return (
    <Grid.Col span={span ?? DEFAULT_SPAN}>
      <TextField
        fieldName={`${prefix}.cityEnglish`}
        label={t(`${TRANS_KEY}.CITY_ENGLISH_LABEL`)}
        {...props}
      />
    </Grid.Col>
  );
};
